module.exports = __webpack_public_path__ + "static/media/print.e021a491.svg";